import React, { useState } from 'react';
import { Button, Menu, Text } from '@mantine/core';
import {
  IconChevronDown,
  IconDownload,
  type TablerIcon,
} from '@tabler/icons-react';
import { ganttToolbarButtonProps } from './ganttToolbarStyles';
import type { GanttToolsActionItem } from './tools/GanttToolsActionList';

export interface GanttExportMenuProps {
  items: GanttToolsActionItem[];
}

/** Row-1 Export dropdown (XML / Excel / PDF). */
export function GanttExportMenu({ items }: GanttExportMenuProps) {
  const [opened, setOpened] = useState(false);

  return (
    <Menu
      opened={opened}
      onChange={setOpened}
      shadow="md"
      radius="md"
      width={280}
      position="bottom-end"
      withinPortal
    >
      <Menu.Target>
        <Button
          {...ganttToolbarButtonProps}
          variant="default"
          type="button"
          leftSection={<IconDownload size={14} stroke={1.75} />}
          rightSection={<IconChevronDown size={14} stroke={1.75} />}
          onClick={() => setOpened((o) => !o)}
          aria-label="Export"
          aria-expanded={opened}
        >
          Export
        </Button>
      </Menu.Target>
      <Menu.Dropdown>
        {items.map((item) => {
          const Icon = item.Icon as TablerIcon | undefined;
          return (
            <Menu.Item
              key={item.id}
              disabled={item.disabled}
              leftSection={Icon ? <Icon size={14} stroke={1.6} /> : undefined}
              onClick={() => {
                if (item.disabled) return;
                item.onActivate();
                setOpened(false);
              }}
            >
              <Text size="sm" fw={600}>
                {item.label}
              </Text>
              {item.description ? (
                <Text size="xs" c="dimmed" lineClamp={2}>
                  {item.description}
                </Text>
              ) : null}
            </Menu.Item>
          );
        })}
      </Menu.Dropdown>
    </Menu>
  );
}
